import React, { Fragment } from "react";
import { withRouter } from "react-router-dom";
import { GoogleTracking } from "../../google/GoogleTracking";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useTranslation } from "react-i18next";

const ListSection = (props) => {
  const { t, i18n } = useTranslation();

  let flipped = false;

  const getInternalPath = (page_code) => {
    switch (page_code) {
      case "LANDING":
        return `/${i18n.language}/`;
      case "ABOUT":
        return `/${i18n.language}/about`;
      default:
        return `/${i18n.language}/${page_code}`;
    }
  };

  return (
    <Fragment>
      {props.pillars.length > 0 ? (
        <section ref={props.sectionRef} className="page-section">
          <div className="container-fluid">
            {props.pillars.map((pillar, index) => {
              const side1 = (
                <div
                  className={
                    (pillar.img ? "col-md-8" : "col-md-12") +
                    " half-content pr-lg-0 mt-4"
                  }
                >
                  <div className="">
                    <div
                      className="content p-4 mb-0"
                      dangerouslySetInnerHTML={{ __html: t(pillar.value) }}
                      style={{
                        direction: "ltr",
                      }}
                    ></div>
                  </div>
                  {pillar.cta ? (
                    <Fragment>
                      <div className="">
                        <div className="content px-4 pt-0 mb-0">
                          {pillar.cta.target === "external" ? (
                            <a
                              className="btn btn-primary ml-0 mr-0 pillar-cta btn-lg"
                              href={pillar.cta.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={() => {
                                if (pillar.cta.ga_action) {
                                  GoogleTracking({
                                    ga_data: {
                                      type: "event",
                                      data: {
                                        category: pillar.cta.ga_category,
                                        action: pillar.cta.ga_action,
                                        label: pillar.cta.ga_action_label,
                                      },
                                    },
                                  });
                                } else {
                                  GoogleTracking({
                                    ga_data: {
                                      type: "event",
                                      data: {
                                        category: t(pillar.cta.label),
                                        action:
                                          "User clicked on " + t(pillar.cta.label),
                                        label: "PAGE_SECTION_CTA",
                                      },
                                    },
                                  });
                                }
                              }}
                            >
                              <span>{t(pillar.cta.label)}</span>
                            </a>
                          ) : (
                            <button
                              className="btn btn-primary ml-0 mr-0 pillar-cta"
                              onClick={() => {
                                if (pillar.cta.ga_action) {
                                  GoogleTracking({
                                    ga_data: {
                                      type: "event",
                                      data: {
                                        category: pillar.cta.ga_category,
                                        action: pillar.cta.ga_action,
                                        label: pillar.cta.ga_action_label,
                                      },
                                    },
                                  });
                                } else {
                                  GoogleTracking({
                                    ga_data: {
                                      type: "event",
                                      data: {
                                        category:
                                          "Page sections CTA - " +
                                          pillar.cta.code,
                                        action:
                                          "User clicked on " + t(pillar.cta.label),
                                        label: "PAGE_SECTION_CTA",
                                      },
                                    },
                                  });
                                }

                                props.history.push(
                                  getInternalPath(pillar.cta.code)
                                );
                              }}
                            >
                              <span>{t(pillar.cta.label)}</span>
                            </button>
                          )}
                        </div>
                      </div>
                    </Fragment>
                  ) : null}
                </div>
              );

              const side2 = pillar.img ? (
                <div className="col-md-4 pl-lg-0 mt-4">
                  <div className="">
                    <div
                      className={
                        "content p-4 page-section-img-container " +
                        (flipped ? "flipped" : "") +
                        " mb-20"
                      }
                      style={{
                        minHeight: "300px",
                      }}
                    >
                      <LazyLoadImage
                        alt={pillar.img}
                        src={pillar.img}
                        style={{
                          maxWidth: "100%",
                          maxHeight: "300px"
                        }}
                      />
                    </div>
                  </div>
                </div>
              ) : null;

              const content = flipped ? (
                <div className="row bg-gray">
                  <div className="container panel-section">
                    <div className="row flipped-container-row" style={{}}>
                      {side1}
                      {side2}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="row bg-white">
                  <div className="container panel-section">
                    <div className="row non-flipped-container-row">
                      {side1}
                      {side2}
                    </div>
                  </div>
                </div>
              );

              flipped = !flipped;

              return <Fragment key={index}>{content}</Fragment>;
            })}
          </div>
        </section>
      ) : (
        ""
      )}
    </Fragment>
  );
};

export default withRouter(ListSection);
